import React from 'react';
import { X, CheckCircle2 } from 'lucide-react';
export function InvisibleDecisions() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-black" data-id="element-660">
      <div className="max-w-7xl mx-auto" data-id="element-661">
        <div className="text-center mb-16" data-id="element-662">
          <h2 className="text-4xl md:text-5xl font-bold font-['Syne'] text-white mb-4" data-id="element-663">
            See It In Action: Client Communications
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-664">
          {/* Without Context Engineering */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10" data-id="element-665">
            <div className="flex items-center gap-3 mb-8" data-id="element-666">
              <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-667">
                <X className="w-6 h-6 text-red-400" data-id="element-668" />
              </div>
              <h3 className="text-2xl font-bold font-['Syne'] text-white" data-id="element-669">
                Without Context Engineering
              </h3>
            </div>

            <div className="mb-8" data-id="element-670">
              <p className="text-lg font-semibold text-white mb-4" data-id="element-671">
                AI Guesses:
              </p>
              <ul className="space-y-3" data-id="element-672">
                <GuessItem text="Who is the audience?" data-id="element-673" />
                <GuessItem text="What tone is appropriate?" data-id="element-674" />
                <GuessItem text="Which rules apply?" data-id="element-675" />
                <GuessItem text="What can I say?" data-id="element-676" />
                <GuessItem text="How formal should I be?" data-id="element-677" />
              </ul>
            </div>

            <div className="pt-6 border-t border-white/10" data-id="element-678">
              <p className="text-sm font-bold text-red-400 uppercase tracking-wide mb-2" data-id="element-679">
                Result:
              </p>
              <p className="text-white/80 text-lg" data-id="element-680">
                Generic, risky, multiple review cycles
              </p>
            </div>
          </div>

          {/* With Context Engineering */}
          <div className="bg-white/5 border border-green-500/30 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-681">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-bl-full" data-id="element-682"></div>

            <div className="flex items-center gap-3 mb-8 relative z-10" data-id="element-683">
              <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-684">
                <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-685" />
              </div>
              <h3 className="text-2xl font-bold font-['Syne'] text-white" data-id="element-686">
                With Context Engineering
              </h3>
            </div>

            <div className="mb-8 relative z-10" data-id="element-687">
              <p className="text-lg font-semibold text-white mb-4" data-id="element-688">AI Knows:</p>
              <ul className="space-y-3" data-id="element-689">
                <KnowsItem text="Client relationship type and history" data-id="element-690" />
                <KnowsItem text="Regulatory compliance requirements" data-id="element-691" />
                <KnowsItem text="Approved messaging frameworks" data-id="element-692" />
                <KnowsItem text="Prohibited claims and statements" data-id="element-693" />
                <KnowsItem text="Brand voice and tone standards" data-id="element-694" />
              </ul>
            </div>

            <div className="pt-6 border-t border-white/10 relative z-10" data-id="element-695">
              <p className="text-sm font-bold text-green-500 uppercase tracking-wide mb-2" data-id="element-696">
                Result:
              </p>
              <p className="text-white text-lg font-medium" data-id="element-697">
                Client-ready, minimal reviews
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function GuessItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-3" data-id="element-698">
      <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-699" />
      <span className="text-white/70 leading-relaxed" data-id="element-700">{text}</span>
    </li>;
}
function KnowsItem({
  text
}: {
  text: string;
}) {
  return <li className="flex items-start gap-3" data-id="element-701">
      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-702" />
      <span className="text-white/90 leading-relaxed" data-id="element-703">{text}</span>
    </li>;
}